import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { ProjectDto } from '../../../core/mceapi.client.generated';
import { FieldTree, FormField, SchemaPathTree, required } from '@angular/forms/signals';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';


export interface ProjectDescription {
  uid: string;
  projectNumber: string;
  projectName: string;
}

export function buildProjectDescriptionSchema(path: SchemaPathTree<ProjectDescription>) {
  required(path.projectNumber, { message: `Project Number is required` });
  required(path.projectName, { message: `Project Name is required` });
};

export function createProjectDescription(project: ProjectDto) {
  return signal<ProjectDescription>({
    uid: project.uid ?? '',
    projectNumber: project.projectNumber ?? '',
    projectName: project.projectName ?? ''
  });
}

@Component({
  selector: 'project-edit-description',
  imports: [FormField, MatInputModule, MatIconModule, MatTooltipModule, ClipboardModule],
  templateUrl: `./project-edit-description.component.html`,
  styleUrl: `./project-edit-description.component.scss`
})
export class ProjectDescriptionComponent {

  readonly form = input.required<FieldTree<ProjectDescription>>();


}
